function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $8d360bad5ca5649f$exports = {};
/* smoothscroll v0.4.4 - 2019 - Dustan Kasten, Jeremias Menichelli - MIT License */ (function() {
    "use strict";
    // polyfill
    function polyfill() {
        // aliases
        var w = window;
        var d = document;
        // return if scroll behavior is supported and polyfill is not forced
        if ("scrollBehavior" in d.documentElement.style && w.__forceSmoothScrollPolyfill__ !== true) return;
        // globals
        var Element = w.HTMLElement || w.Element;
        var SCROLL_TIME = 468;
        // object gathering original scroll methods
        var original = {
            scroll: w.scroll || w.scrollTo,
            scrollBy: w.scrollBy,
            elementScroll: Element.prototype.scroll || scrollElement,
            scrollIntoView: Element.prototype.scrollIntoView
        };
        // define timing method
        var now = w.performance && w.performance.now ? w.performance.now.bind(w.performance) : Date.now;
        /**
     * indicates if a the current browser is made by Microsoft
     * @method isMicrosoftBrowser
     * @param {String} userAgent
     * @returns {Boolean}
     */ function isMicrosoftBrowser(userAgent) {
            var userAgentPatterns = [
                "MSIE ",
                "Trident/",
                "Edge/"
            ];
            return new RegExp(userAgentPatterns.join("|")).test(userAgent);
        }
        /*
     * IE has rounding bug rounding down clientHeight and clientWidth and
     * rounding up scrollHeight and scrollWidth causing false positives
     * on hasScrollableSpace
     */ var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;
        /**
     * changes scroll position inside an element
     * @method scrollElement
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */ function scrollElement(x, y) {
            this.scrollLeft = x;
            this.scrollTop = y;
        }
        /**
     * returns result of applying ease math function to a number
     * @method ease
     * @param {Number} k
     * @returns {Number}
     */ function ease(k) {
            return 0.5 * (1 - Math.cos(Math.PI * k));
        }
        /**
     * indicates if a smooth behavior should be applied
     * @method shouldBailOut
     * @param {Number|Object} firstArg
     * @returns {Boolean}
     */ function shouldBailOut(firstArg) {
            if (firstArg === null || typeof firstArg !== "object" || firstArg.behavior === undefined || firstArg.behavior === "auto" || firstArg.behavior === "instant") // first argument is not an object/null
            // or behavior is auto, instant or undefined
            return true;
            if (typeof firstArg === "object" && firstArg.behavior === "smooth") // first argument is an object and behavior is smooth
            return false;
            // throw error when behavior is not supported
            throw new TypeError("behavior member of ScrollOptions " + firstArg.behavior + " is not a valid value for enumeration ScrollBehavior.");
        }
        /**
     * indicates if an element has scrollable space in the provided axis
     * @method hasScrollableSpace
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */ function hasScrollableSpace(el, axis) {
            if (axis === "Y") return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
            if (axis === "X") return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
        }
        /**
     * indicates if an element has a scrollable overflow property in the axis
     * @method canOverflow
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */ function canOverflow(el, axis) {
            var overflowValue = w.getComputedStyle(el, null)["overflow" + axis];
            return overflowValue === "auto" || overflowValue === "scroll";
        }
        /**
     * indicates if an element can be scrolled in either axis
     * @method isScrollable
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */ function isScrollable(el) {
            var isScrollableY = hasScrollableSpace(el, "Y") && canOverflow(el, "Y");
            var isScrollableX = hasScrollableSpace(el, "X") && canOverflow(el, "X");
            return isScrollableY || isScrollableX;
        }
        /**
     * finds scrollable parent of an element
     * @method findScrollableParent
     * @param {Node} el
     * @returns {Node} el
     */ function findScrollableParent(el) {
            while(el !== d.body && isScrollable(el) === false)el = el.parentNode || el.host;
            return el;
        }
        /**
     * self invoked function that, given a context, steps through scrolling
     * @method step
     * @param {Object} context
     * @returns {undefined}
     */ function step(context) {
            var time = now();
            var value;
            var currentX;
            var currentY;
            var elapsed = (time - context.startTime) / SCROLL_TIME;
            // avoid elapsed times higher than one
            elapsed = elapsed > 1 ? 1 : elapsed;
            // apply easing to elapsed time
            value = ease(elapsed);
            currentX = context.startX + (context.x - context.startX) * value;
            currentY = context.startY + (context.y - context.startY) * value;
            context.method.call(context.scrollable, currentX, currentY);
            // scroll more if we have not reached our destination
            if (currentX !== context.x || currentY !== context.y) w.requestAnimationFrame(step.bind(w, context));
        }
        /**
     * scrolls window or element with a smooth behavior
     * @method smoothScroll
     * @param {Object|Node} el
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */ function smoothScroll(el, x, y) {
            var scrollable;
            var startX;
            var startY;
            var method;
            var startTime = now();
            // define scroll context
            if (el === d.body) {
                scrollable = w;
                startX = w.scrollX || w.pageXOffset;
                startY = w.scrollY || w.pageYOffset;
                method = original.scroll;
            } else {
                scrollable = el;
                startX = el.scrollLeft;
                startY = el.scrollTop;
                method = scrollElement;
            }
            // scroll looping over a frame
            step({
                scrollable: scrollable,
                method: method,
                startTime: startTime,
                startX: startX,
                startY: startY,
                x: x,
                y: y
            });
        }
        // ORIGINAL METHODS OVERRIDES
        // w.scroll and w.scrollTo
        w.scroll = w.scrollTo = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                original.scroll.call(w, arguments[0].left !== undefined ? arguments[0].left : typeof arguments[0] !== "object" ? arguments[0] : w.scrollX || w.pageXOffset, // use top prop, second argument if present or fallback to scrollY
                arguments[0].top !== undefined ? arguments[0].top : arguments[1] !== undefined ? arguments[1] : w.scrollY || w.pageYOffset);
                return;
            }
            // LET THE SMOOTHNESS BEGIN!
            smoothScroll.call(w, d.body, arguments[0].left !== undefined ? ~~arguments[0].left : w.scrollX || w.pageXOffset, arguments[0].top !== undefined ? ~~arguments[0].top : w.scrollY || w.pageYOffset);
        };
        // w.scrollBy
        w.scrollBy = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0])) {
                original.scrollBy.call(w, arguments[0].left !== undefined ? arguments[0].left : typeof arguments[0] !== "object" ? arguments[0] : 0, arguments[0].top !== undefined ? arguments[0].top : arguments[1] !== undefined ? arguments[1] : 0);
                return;
            }
            // LET THE SMOOTHNESS BEGIN!
            smoothScroll.call(w, d.body, ~~arguments[0].left + (w.scrollX || w.pageXOffset), ~~arguments[0].top + (w.scrollY || w.pageYOffset));
        };
        // Element.prototype.scroll and Element.prototype.scrollTo
        Element.prototype.scroll = Element.prototype.scrollTo = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                // if one number is passed, throw error to match Firefox implementation
                if (typeof arguments[0] === "number" && arguments[1] === undefined) throw new SyntaxError("Value could not be converted");
                original.elementScroll.call(this, // use left prop, first number argument or fallback to scrollLeft
                arguments[0].left !== undefined ? ~~arguments[0].left : typeof arguments[0] !== "object" ? ~~arguments[0] : this.scrollLeft, // use top prop, second argument or fallback to scrollTop
                arguments[0].top !== undefined ? ~~arguments[0].top : arguments[1] !== undefined ? ~~arguments[1] : this.scrollTop);
                return;
            }
            var left = arguments[0].left;
            var top = arguments[0].top;
            // LET THE SMOOTHNESS BEGIN!
            smoothScroll.call(this, this, typeof left === "undefined" ? this.scrollLeft : ~~left, typeof top === "undefined" ? this.scrollTop : ~~top);
        };
        // Element.prototype.scrollBy
        Element.prototype.scrollBy = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                original.elementScroll.call(this, arguments[0].left !== undefined ? ~~arguments[0].left + this.scrollLeft : ~~arguments[0] + this.scrollLeft, arguments[0].top !== undefined ? ~~arguments[0].top + this.scrollTop : ~~arguments[1] + this.scrollTop);
                return;
            }
            this.scroll({
                left: ~~arguments[0].left + this.scrollLeft,
                top: ~~arguments[0].top + this.scrollTop,
                behavior: arguments[0].behavior
            });
        };
        // Element.prototype.scrollIntoView
        Element.prototype.scrollIntoView = function() {
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                original.scrollIntoView.call(this, arguments[0] === undefined ? true : arguments[0]);
                return;
            }
            // LET THE SMOOTHNESS BEGIN!
            var scrollableParent = findScrollableParent(this);
            var parentRects = scrollableParent.getBoundingClientRect();
            var clientRects = this.getBoundingClientRect();
            if (scrollableParent !== d.body) {
                // reveal element inside parent
                smoothScroll.call(this, scrollableParent, scrollableParent.scrollLeft + clientRects.left - parentRects.left, scrollableParent.scrollTop + clientRects.top - parentRects.top);
                // reveal parent in viewport unless is fixed
                if (w.getComputedStyle(scrollableParent).position !== "fixed") w.scrollBy({
                    left: parentRects.left,
                    top: parentRects.top,
                    behavior: "smooth"
                });
            } else // reveal element in viewport
            w.scrollBy({
                left: clientRects.left,
                top: clientRects.top,
                behavior: "smooth"
            });
        };
    }
    // commonjs
    $8d360bad5ca5649f$exports = {
        polyfill: polyfill
    };
})();


var $03b4177a10313289$exports = {};
!function(e, t) {
    $03b4177a10313289$exports = t();
}($03b4177a10313289$exports, function() {
    return (()=>{
        "use strict";
        var e = {
            d: (t, n)=>{
                for(var r in n)e.o(n, r) && !e.o(t, r) && Object.defineProperty(t, r, {
                    enumerable: !0,
                    get: n[r]
                });
            },
            o: (e, t)=>Object.prototype.hasOwnProperty.call(e, t)
        }, t = {};
        function n(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var r = Object.getOwnPropertySymbols(e);
                t && (r = r.filter(function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })), n.push.apply(n, r);
            }
            return n;
        }
        function r(e) {
            for(var t = 1; t < arguments.length; t++){
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? n(Object(r), !0).forEach(function(t) {
                    o(e, t, r[t]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : n(Object(r)).forEach(function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                });
            }
            return e;
        }
        function o(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = n, e;
        }
        e.d(t, {
            default: ()=>j
        });
        var a = "Sal was not initialised! Probably it is used in SSR.", s = "Your browser does not support IntersectionObserver!\nGet a polyfill from here:\nhttps://github.com/w3c/IntersectionObserver/tree/master/polyfill", i = {
            root: null,
            rootMargin: "0% 50%",
            threshold: .5,
            animateClassName: "sal-animate",
            disabledClassName: "sal-disabled",
            enterEventName: "sal:in",
            exitEventName: "sal:out",
            selector: "[data-sal]",
            once: !0,
            disabled: !1
        }, l = [], c = null, u = function(e) {
            e && e !== i && (i = r(r({}, i), e));
        }, d = function(e) {
            e.classList.remove(i.animateClassName);
        }, f = function(e, t) {
            var n = new CustomEvent(e, {
                bubbles: !0,
                detail: t
            });
            t.target.dispatchEvent(n);
        }, b = function() {
            document.body.classList.add(i.disabledClassName);
        }, p = function() {
            c.disconnect(), c = null;
        }, m = function() {
            return i.disabled || "function" == typeof i.disabled && i.disabled();
        }, v = function(e, t) {
            e.forEach(function(e) {
                var n = e.target, r = void 0 !== n.dataset.salRepeat, o = void 0 !== n.dataset.salOnce, a = r || !(o || i.once);
                e.intersectionRatio >= i.threshold ? (function(e) {
                    e.target.classList.add(i.animateClassName), f(i.enterEventName, e);
                }(e), a || t.unobserve(n)) : a && function(e) {
                    d(e.target), f(i.exitEventName, e);
                }(e);
            });
        }, y = function() {
            var e = [].filter.call(document.querySelectorAll(i.selector), function(e) {
                return !function(e) {
                    return e.classList.contains(i.animateClassName);
                }(e, i.animateClassName);
            });
            return e.forEach(function(e) {
                return c.observe(e);
            }), e;
        }, O = function() {
            b(), p();
        }, h = function() {
            document.body.classList.remove(i.disabledClassName), c = new IntersectionObserver(v, {
                root: i.root,
                rootMargin: i.rootMargin,
                threshold: i.threshold
            }), l = y();
        }, g = function() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            p(), Array.from(document.querySelectorAll(i.selector)).forEach(d), u(e), h();
        }, w = function() {
            var e = y();
            l.push(e);
        };
        const j = function() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : i;
            if (u(e), "undefined" == typeof window) return console.warn(a), {
                elements: l,
                disable: O,
                enable: h,
                reset: g,
                update: w
            };
            if (!window.IntersectionObserver) throw b(), Error(s);
            return m() ? b() : h(), {
                elements: l,
                disable: O,
                enable: h,
                reset: g,
                update: w
            };
        };
        return t.default;
    })();
});


window.FontAwesomeKitConfig = {
    asyncLoading: {
        enabled: true
    },
    autoA11y: {
        enabled: true
    },
    baseUrl: "https://ka-f.fontawesome.com",
    baseUrlKit: "https://kit.fontawesome.com",
    detectConflictsUntil: null,
    iconUploads: {},
    id: 6743296,
    license: "pro",
    method: "css",
    minify: {
        enabled: true
    },
    token: "a076d05399",
    v4FontFaceShim: {
        enabled: true
    },
    v4shim: {
        enabled: true
    },
    version: "5.15.4"
};
!function(t) {
    "function" == typeof define && define.amd ? define("kit-loader", t) : t();
}(function() {
    "use strict";
    function t(e) {
        return (t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
            return typeof t;
        } : function(t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        })(e);
    }
    function e(t, e, n) {
        return e in t ? Object.defineProperty(t, e, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t[e] = n, t;
    }
    function n(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(t);
            e && (r = r.filter(function(e) {
                return Object.getOwnPropertyDescriptor(t, e).enumerable;
            })), n.push.apply(n, r);
        }
        return n;
    }
    function r(t) {
        for(var r = 1; r < arguments.length; r++){
            var o = null != arguments[r] ? arguments[r] : {};
            r % 2 ? n(Object(o), !0).forEach(function(n) {
                e(t, n, o[n]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(o)) : n(Object(o)).forEach(function(e) {
                Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(o, e));
            });
        }
        return t;
    }
    function o(t, e) {
        return function(t) {
            if (Array.isArray(t)) return t;
        }(t) || function(t, e) {
            if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t))) return;
            var n = [], r = !0, o = !1, i = void 0;
            try {
                for(var c, a = t[Symbol.iterator](); !(r = (c = a.next()).done) && (n.push(c.value), !e || n.length !== e); r = !0);
            } catch (t) {
                o = !0, i = t;
            } finally{
                try {
                    r || null == a.return || a.return();
                } finally{
                    if (o) throw i;
                }
            }
            return n;
        }(t, e) || function(t, e) {
            if (!t) return;
            if ("string" == typeof t) return i(t, e);
            var n = Object.prototype.toString.call(t).slice(8, -1);
            "Object" === n && t.constructor && (n = t.constructor.name);
            if ("Map" === n || "Set" === n) return Array.from(t);
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return i(t, e);
        }(t, e) || function() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function i(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for(var n = 0, r = new Array(e); n < e; n++)r[n] = t[n];
        return r;
    }
    function c(t, e) {
        var n = e && e.addOn || "", r = e && e.baseFilename || t.license + n, o = e && e.minify ? ".min" : "", i = e && e.fileSuffix || t.method, c = e && e.subdir || t.method;
        return t.baseUrl + "/releases/" + ("latest" === t.version ? "latest" : "v".concat(t.version)) + "/" + c + "/" + r + o + "." + i;
    }
    function a(t) {
        return t.baseUrlKit + "/" + t.token + "/" + t.id + "/kit-upload.css";
    }
    function u(t, e) {
        var n = e || [
            "fa"
        ], r = "." + Array.prototype.join.call(n, ",."), o = t.querySelectorAll(r);
        Array.prototype.forEach.call(o, function(e) {
            var n = e.getAttribute("title");
            e.setAttribute("aria-hidden", "true");
            var r = !e.nextElementSibling || !e.nextElementSibling.classList.contains("sr-only");
            if (n && r) {
                var o = t.createElement("span");
                o.innerHTML = n, o.classList.add("sr-only"), e.parentNode.insertBefore(o, e.nextSibling);
            }
        });
    }
    var f, s = function() {}, d = "undefined" != typeof $parcel$global && void 0 !== $parcel$global.process && "function" == typeof $parcel$global.process.emit, l = "undefined" == typeof setImmediate ? setTimeout : setImmediate, h = [];
    function m() {
        for(var t = 0; t < h.length; t++)h[t][0](h[t][1]);
        h = [], f = !1;
    }
    function p(t, e) {
        h.push([
            t,
            e
        ]), f || (f = !0, l(m, 0));
    }
    function y(t) {
        var e = t.owner, n = e._state, r = e._data, o = t[n], i = t.then;
        if ("function" == typeof o) {
            n = "fulfilled";
            try {
                r = o(r);
            } catch (t) {
                w(i, t);
            }
        }
        b(i, r) || ("fulfilled" === n && v(i, r), "rejected" === n && w(i, r));
    }
    function b(e, n) {
        var r;
        try {
            if (e === n) throw new TypeError("A promises callback cannot return that same promise.");
            if (n && ("function" == typeof n || "object" === t(n))) {
                var o = n.then;
                if ("function" == typeof o) return o.call(n, function(t) {
                    r || (r = !0, n === t ? g(e, t) : v(e, t));
                }, function(t) {
                    r || (r = !0, w(e, t));
                }), !0;
            }
        } catch (t) {
            return r || w(e, t), !0;
        }
        return !1;
    }
    function v(t, e) {
        t !== e && b(t, e) || g(t, e);
    }
    function g(t, e) {
        "pending" === t._state && (t._state = "settled", t._data = e, p(S, t));
    }
    function w(t, e) {
        "pending" === t._state && (t._state = "settled", t._data = e, p(O, t));
    }
    function A(t) {
        t._then = t._then.forEach(y);
    }
    function S(t) {
        t._state = "fulfilled", A(t);
    }
    function O(t) {
        t._state = "rejected", A(t), !t._handled && d && $parcel$global.process.emit("unhandledRejection", t._data, t);
    }
    function j(t) {
        $parcel$global.process.emit("rejectionHandled", t);
    }
    function E(t) {
        if ("function" != typeof t) throw new TypeError("Promise resolver " + t + " is not a function");
        if (this instanceof E == !1) throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
        this._then = [], function(t, e) {
            function n(t) {
                w(e, t);
            }
            try {
                t(function(t) {
                    v(e, t);
                }, n);
            } catch (t) {
                n(t);
            }
        }(t, this);
    }
    E.prototype = {
        constructor: E,
        _state: "pending",
        _then: null,
        _data: void 0,
        _handled: !1,
        then: function(t, e) {
            var n = {
                owner: this,
                then: new this.constructor(s),
                fulfilled: t,
                rejected: e
            };
            return !e && !t || this._handled || (this._handled = !0, "rejected" === this._state && d && p(j, this)), "fulfilled" === this._state || "rejected" === this._state ? p(y, n) : this._then.push(n), n.then;
        },
        catch: function(t) {
            return this.then(null, t);
        }
    }, E.all = function(t) {
        if (!Array.isArray(t)) throw new TypeError("You must pass an array to Promise.all().");
        return new E(function(e, n) {
            var r = [], o = 0;
            function i(t) {
                return o++, function(n) {
                    r[t] = n, --o || e(r);
                };
            }
            for(var c, a = 0; a < t.length; a++)(c = t[a]) && "function" == typeof c.then ? c.then(i(a), n) : r[a] = c;
            o || e(r);
        });
    }, E.race = function(t) {
        if (!Array.isArray(t)) throw new TypeError("You must pass an array to Promise.race().");
        return new E(function(e, n) {
            for(var r, o = 0; o < t.length; o++)(r = t[o]) && "function" == typeof r.then ? r.then(e, n) : e(r);
        });
    }, E.resolve = function(e) {
        return e && "object" === t(e) && e.constructor === E ? e : new E(function(t) {
            t(e);
        });
    }, E.reject = function(t) {
        return new E(function(e, n) {
            n(t);
        });
    };
    var _ = "function" == typeof Promise ? Promise : E;
    function P(t, e) {
        var n = e.fetch, r = e.XMLHttpRequest, o = e.token, i = t;
        return "URLSearchParams" in window ? (i = new URL(t)).searchParams.set("token", o) : i = i + "?token=" + encodeURIComponent(o), i = i.toString(), new _(function(t, e) {
            if ("function" == typeof n) n(i, {
                mode: "cors",
                cache: "default"
            }).then(function(t) {
                if (t.ok) return t.text();
                throw new Error("");
            }).then(function(e) {
                t(e);
            }).catch(e);
            else if ("function" == typeof r) {
                var o = new r();
                o.addEventListener("loadend", function() {
                    this.responseText ? t(this.responseText) : e(new Error(""));
                });
                [
                    "abort",
                    "error",
                    "timeout"
                ].map(function(t) {
                    o.addEventListener(t, function() {
                        e(new Error(""));
                    });
                }), o.open("GET", i), o.send();
            } else e(new Error(""));
        });
    }
    function C(t, e, n) {
        var r = t;
        return [
            [
                /(url\("?)\.\.\/\.\.\/\.\./g,
                function(t, n) {
                    return "".concat(n).concat(e);
                }
            ],
            [
                /(url\("?)\.\.\/webfonts/g,
                function(t, r) {
                    return "".concat(r).concat(e, "/releases/v").concat(n, "/webfonts");
                }
            ],
            [
                /(url\("?)https:\/\/kit-pro([^.])*\.fontawesome\.com/g,
                function(t, n) {
                    return "".concat(n).concat(e);
                }
            ]
        ].forEach(function(t) {
            var e = o(t, 2), n = e[0], i = e[1];
            r = r.replace(n, i);
        }), r;
    }
    function F(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : function() {}, o = e.document || o, i = u.bind(u, o, [
            "fa",
            "fab",
            "fas",
            "far",
            "fal",
            "fad",
            "fak"
        ]), f = Object.keys(t.iconUploads || {}).length > 0;
        t.autoA11y.enabled && n(i);
        var s = [
            {
                id: "fa-main",
                addOn: void 0
            }
        ];
        t.v4shim.enabled && s.push({
            id: "fa-v4-shims",
            addOn: "-v4-shims"
        }), t.v4FontFaceShim.enabled && s.push({
            id: "fa-v4-font-face",
            addOn: "-v4-font-face"
        }), f && s.push({
            id: "fa-kit-upload",
            customCss: !0
        });
        var d = s.map(function(n) {
            return new _(function(o, i) {
                P(n.customCss ? a(t) : c(t, {
                    addOn: n.addOn,
                    minify: t.minify.enabled
                }), e).then(function(i) {
                    o(U(i, r(r({}, e), {}, {
                        baseUrl: t.baseUrl,
                        version: t.version,
                        id: n.id,
                        contentFilter: function(t, e) {
                            return C(t, e.baseUrl, e.version);
                        }
                    })));
                }).catch(i);
            });
        });
        return _.all(d);
    }
    function U(t, e) {
        var n = e.contentFilter || function(t, e) {
            return t;
        }, r = document.createElement("style"), o = document.createTextNode(n(t, e));
        return r.appendChild(o), r.media = "all", e.id && r.setAttribute("id", e.id), e && e.detectingConflicts && e.detectionIgnoreAttr && r.setAttributeNode(document.createAttribute(e.detectionIgnoreAttr)), r;
    }
    function k(t, e) {
        e.autoA11y = t.autoA11y.enabled, "pro" === t.license && (e.autoFetchSvg = !0, e.fetchSvgFrom = t.baseUrl + "/releases/" + ("latest" === t.version ? "latest" : "v".concat(t.version)) + "/svgs", e.fetchUploadedSvgFrom = t.uploadsUrl);
        var n = [];
        return t.v4shim.enabled && n.push(new _(function(n, o) {
            P(c(t, {
                addOn: "-v4-shims",
                minify: t.minify.enabled
            }), e).then(function(t) {
                n(I(t, r(r({}, e), {}, {
                    id: "fa-v4-shims"
                })));
            }).catch(o);
        })), n.push(new _(function(n, o) {
            P(c(t, {
                minify: t.minify.enabled
            }), e).then(function(t) {
                var o = I(t, r(r({}, e), {}, {
                    id: "fa-main"
                }));
                n(function(t, e) {
                    var n = e && void 0 !== e.autoFetchSvg ? e.autoFetchSvg : void 0, r = e && void 0 !== e.autoA11y ? e.autoA11y : void 0;
                    void 0 !== r && t.setAttribute("data-auto-a11y", r ? "true" : "false");
                    n && (t.setAttributeNode(document.createAttribute("data-auto-fetch-svg")), t.setAttribute("data-fetch-svg-from", e.fetchSvgFrom), t.setAttribute("data-fetch-uploaded-svg-from", e.fetchUploadedSvgFrom));
                    return t;
                }(o, e));
            }).catch(o);
        })), _.all(n);
    }
    function I(t, e) {
        var n = document.createElement("SCRIPT"), r = document.createTextNode(t);
        return n.appendChild(r), n.referrerPolicy = "strict-origin", e.id && n.setAttribute("id", e.id), e && e.detectingConflicts && e.detectionIgnoreAttr && n.setAttributeNode(document.createAttribute(e.detectionIgnoreAttr)), n;
    }
    function L(t) {
        var e, n = [], r = document, o = r.documentElement.doScroll, i = (o ? /^loaded|^c/ : /^loaded|^i|^c/).test(r.readyState);
        i || r.addEventListener("DOMContentLoaded", e = function() {
            for(r.removeEventListener("DOMContentLoaded", e), i = 1; e = n.shift();)e();
        }), i ? setTimeout(t, 0) : n.push(t);
    }
    function T(t) {
        "undefined" != typeof MutationObserver && new MutationObserver(t).observe(document, {
            childList: !0,
            subtree: !0
        });
    }
    try {
        if (window.FontAwesomeKitConfig) {
            var x = window.FontAwesomeKitConfig, M = {
                detectingConflicts: x.detectConflictsUntil && new Date() <= new Date(x.detectConflictsUntil),
                detectionIgnoreAttr: "data-fa-detection-ignore",
                fetch: window.fetch,
                token: x.token,
                XMLHttpRequest: window.XMLHttpRequest,
                document: document
            }, D = document.currentScript, N = D ? D.parentElement : document.head;
            (function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                return "js" === t.method ? k(t, e) : "css" === t.method ? F(t, e, function(t) {
                    L(t), T(t);
                }) : void 0;
            })(x, M).then(function(t) {
                t.map(function(t) {
                    try {
                        N.insertBefore(t, D ? D.nextSibling : null);
                    } catch (e) {
                        N.appendChild(t);
                    }
                }), M.detectingConflicts && D && L(function() {
                    D.setAttributeNode(document.createAttribute(M.detectionIgnoreAttr));
                    var t = function(t, e) {
                        var n = document.createElement("script");
                        return e && e.detectionIgnoreAttr && n.setAttributeNode(document.createAttribute(e.detectionIgnoreAttr)), n.src = c(t, {
                            baseFilename: "conflict-detection",
                            fileSuffix: "js",
                            subdir: "js",
                            minify: t.minify.enabled
                        }), n;
                    }(x, M);
                    document.body.appendChild(t);
                });
            }).catch(function(t) {
                console.error("".concat("Font Awesome Kit:", " ").concat(t));
            });
        }
    } catch (t) {
        console.error("".concat("Font Awesome Kit:", " ").concat(t));
    }
});



class $f6500150e0f0f1cb$var$NavbarToggler {
    constructor({ toggler: toggler, target: target }){
        this.toggler = toggler;
        this.menu = target;
    }
    activate() {
        this.toggler?.addEventListener("click", ()=>this._toggle());
        this._activateOnClickMenu();
    }
    _toggle() {
        if (this.toggler?.classList.contains("active")) {
            this.toggler?.classList.remove("active");
            this.menu?.classList.remove("active");
        } else {
            this.toggler?.classList.add("active");
            this.menu?.classList.add("active");
        }
    }
    _activateOnClickMenu() {
        const links = [
            ...document.querySelectorAll(".nav-menu a")
        ];
        links.forEach((link)=>link.addEventListener("click", ()=>{
                this.toggler?.classList.remove("active");
                this.menu?.classList.remove("active");
            }));
    }
}
var $f6500150e0f0f1cb$export$2e2bcd8739ae039 = $f6500150e0f0f1cb$var$NavbarToggler;


(()=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($8d360bad5ca5649f$exports))).polyfill();
    (0, (/*@__PURE__*/$parcel$interopDefault($03b4177a10313289$exports)))({
        once: true
    });
    new (0, $f6500150e0f0f1cb$export$2e2bcd8739ae039)({
        toggler: document.querySelector(".nav__toggler"),
        target: document.querySelector(".nav-menu")
    }).activate();
})();


//# sourceMappingURL=index.710807c1.js.map
